import type { Customer } from '@/types/dispatcher/dashboard.types'
import type { Order, Technician } from '@/types/executives'

export enum UserRoleEnum {
    DISPATCHER = 'dispatcher',
    TENANT_ADMIN = 'tenant_admin',
    EXECUTIVES = 'executives',
    UNAUTHORIZED = 'unauthorized',
    TECHNICIANS = 'technicians',
    SUPER_ADMIN = 'super_admin',
    CUSTOMER = 'customer',
}

export type IUserRole = `${UserRoleEnum}`

export interface User {
    id: number
    fullName: string
    email: string
    photo: string
    phone: string
    role?: UserRoleEnum
    status: 'active' | 'disabled' | 'offline' | 'online' | string
    notifications: string[]
    language: 'en'
    createdAt: string
    roles: UserRoleEnum[]
}

export interface IPagination {
    limit: number
    maxPages: number
    offset: number
    page: number
    total: number
}

export const ROLE_LABELS: Record<UserRoleEnum, string> = {
    [UserRoleEnum.DISPATCHER]: 'Dispatcher',
    [UserRoleEnum.TENANT_ADMIN]: 'Tenant Admin',
    [UserRoleEnum.EXECUTIVES]: 'Executives',
    [UserRoleEnum.UNAUTHORIZED]: 'Unauthorized',
    [UserRoleEnum.TECHNICIANS]: 'Technicians',
    [UserRoleEnum.SUPER_ADMIN]: 'Super Admin',
    [UserRoleEnum.CUSTOMER]: 'Customer',
}

export interface CategoryType {
    thumbnail: null
    id: number
    name: string
    status: string
    order: number
    createdAt: Date
    updatedAt: Date
}

export interface ServiceType {
    thumbail: string
    id: number
    name: string
    description: string
    userId: number
    categoryId: number
    price: number
    status: string
    createdAt: Date
    updatedAt: Date
    category: {
        id: number
        name: string
        status: string
    }
}

export interface IOptionProps {
    label: string
    value: string
}

export interface ITenantSearchResponse {
    orders: Order[]
    technicians: Technician[]
    customers: Customer[]
}
